import { Box, Flex, Heading, HStack } from "@chakra-ui/react";
import { useMonitor } from "./useMonitor";
import { Table } from "../../components/Table/TableWithPagination";
import { FilterPanel } from "../../components/FilterPanel/FilterPanel";

export const Monitor = () => {
  const {
    columns,
    columnData,
    rowsPerPage,
    totalPages,
    handleFilterChange,
    handlePageChange,
    search,
    checkboxes,
    startedBy,
    timeRange,
  } = useMonitor();

  return (
    <Box width="100%">
      <Flex direction="row" width="100%" gap={4}>
        <Box width="15%">
          <Box
            bg="rgba(255, 255, 255, 0.05)"
            backdropFilter="blur(20px)"
            borderRadius="20px"
            border="1px solid rgba(255, 255, 255, 0.1)"
          >
            <FilterPanel
              search={search}
              checkboxes={checkboxes}
              timeRange={timeRange}
              onFilterChange={handleFilterChange}
            />
          </Box>
        </Box>
        <Box width="85%">
          <Box
            bg="rgba(255, 255, 255, 0.05)"
            backdropFilter="blur(20px)"
            borderRadius="20px"
            border="1px solid rgba(255, 255, 255, 0.1)"
          >
            <Box p={6}>
              <HStack justifyContent="space-between">
                <Heading fontSize="18px" fontWeight="600" color="white">
                  Your Processes Activity
                </Heading>
              </HStack>
            </Box>
            <Table
              columns={columns}
              data={columnData}
              intialRowsPerPage={rowsPerPage}
              totalPages={totalPages}
              onPageSizeChange={handlePageChange}
            />
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};
